import { Skeleton } from '@/components/UI/Skeleton'

type Props = {
  /** 表示するスタンプ数（デフォルト: 9） */
  stampCount?: number
}

/**
 * StampSheet の形状に合わせたスケルトンプレースホルダー。
 * スタンプシートのローディング中に表示する。
 */
export function StampSheetSkeleton({ stampCount = 9 }: Props) {
  return (
    <div className="mt-4 rounded-lg pt-6 border border-gray-200 relative overflow-hidden bg-white">
      {/* シート名 */}
      <div className="px-3 flex justify-center">
        <Skeleton variant="text" width="50%" height={20} />
      </div>

      {/* 達成状況 */}
      <div className="mt-1 mr-3 flex justify-end">
        <Skeleton variant="text" width="35%" height={14} />
      </div>

      {/* スタンプグリッド（3列） */}
      <div className="grid grid-cols-3 place-items-center px-2 py-4 gap-y-4">
        {Array.from({ length: stampCount }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: 静的なスケルトン行のため index を key に使用
          <div key={i} className="flex flex-col items-center gap-1 pt-4 w-full">
            <Skeleton variant="circle" width={60} />
            <Skeleton variant="text" width="70%" height={12} />
          </div>
        ))}
      </div>
    </div>
  )
}
